// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__QjGbA","addWidgetButton":"Header_addWidgetButton__2Zmfl","dashboardTabs":"Header_dashboardTabs__2kPsZ","active":"Header_active__3d9_o"};